import React, { useState, createContext } from "react"

export const PostContext = createContext({
    fetchingPosts: false,
    setFetchingPosts: () => {},

    medias: [],
    setMedias: () => {}
})

export const PostProvider = (props) => {
    const { children } = props
    const [fetchingPosts, setFetchingPosts] = useState(false)
    const [medias, setMedias] = useState([])

    return (
        <PostContext.Provider
            value={{
                fetchingPosts,
                setFetchingPosts,

                medias,
                setMedias
            }}
        >
            {children}
        </PostContext.Provider>
    )
}
